import React from 'react';
import { X } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-[#1a1a2e] text-white py-10 md:py-16 px-4" data-id="element-144">
      <div className="max-w-3xl mx-auto text-center" data-id="element-145">
        <h2 className="text-2xl md:text-4xl font-black mb-2 font-['Oswald'] uppercase text-white" data-id="element-146">
          El problema que nadie dice en voz alta
        </h2>
        <p className="text-base md:text-lg text-gray-300 mb-2" data-id="element-147">
          ¿Te pasa que preparar la clase te cansa más que darla?
        </p>
        <p className="text-sm text-gray-400 mb-6" data-id="element-148">
          Si sos docente de primaria, esto seguramente te resulta familiar:
        </p>

        <div className="max-w-lg mx-auto" data-id="element-149">
          <ul className="space-y-3" data-id="element-150">
            {['Pasás horas planificando cada semana', 'Tenés material, pero está desordenado', 'Buscás actividades en muchos lugares', 'Guardás recursos que después no encontrás', 'Terminás improvisando más de lo que querés'].map((item, index) => <li key={index} className="flex items-center gap-3 bg-white/10 p-3 rounded-lg text-left" data-id="element-151">
                <div className="bg-red-500 rounded-full p-0.5 flex-shrink-0" data-id="element-152">
                  <X className="w-4 h-4 text-white" data-id="element-153" />
                </div>
                <span className="text-base font-medium" data-id="element-154">{item}</span>
              </li>)}
          </ul>
        </div>

        <blockquote className="mt-8 text-lg md:text-xl font-serif italic text-yellow-400 max-w-2xl mx-auto leading-relaxed" data-id="element-155">
          "Podría dar mejores clases… si tuviera todo listo."
        </blockquote>
      </div>
    </section>;
}